export const paletteRgba: {
	DarkNeutral300A: {
		r: number;
		g: number;
		b: number;
		a: number;
	};
	Neutral300A: {
		r: number;
		g: number;
		b: number;
		a: number;
	};
} = {
	DarkNeutral300A: { r: 0xe3, g: 0xe4, b: 0xf2, a: 0x1f / 255 },
	Neutral300A: { r: 0x0b, g: 0x12, b: 0x0e, a: 0x24 / 255 },
};
